import Bus from "@/lib/Bus";
import { IFolder } from "../../../../server/src/ai/interface/IFolder"
import { IUser } from "../../../../server/src/user/IUser";
import { IBot, botPrecompiledType, botType } from "../../../../server/src/ai/interface/IBot"
import { ICtx } from "server/src/ai/interface/ICtx";
const bus: Bus = new Bus().getBus();



export class FolderStore {
  private static instance: FolderStore;

  selectedFolder:IFolder | undefined;

  private constructor() { }

  static getInstance(): FolderStore {
    if (!FolderStore.instance) {
      FolderStore.instance = new FolderStore();
    }
    return FolderStore.instance;
  }


  botTemplate(menuItemId: string, prompt:string) {

      const bot: IBot =  {
        id:"",
        type: botType,
        parent_id: menuItemId,
        version: 1,
    
        function_name: "",
        function_desc: "",
        function_call: "",
        function_code: "",
    
        inputs: {},
        outputs: {},
    
        prompt:prompt,
        use: [],
    

    }
    return bot;
  }

  replaceAllOccurrences(input: string, search: string, replacement: string): string {
    const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escapedSearch, 'g');
    return input.replace(regex, replacement);
  }

  name_exists(name:string, bots:IBot[]) {
    for (const b of bots) {
      if (b.function_name==name && b.type!=botPrecompiledType) return true
    }
    return false
  }

  rename_function(bots:IBot[], function_name:string) {
    let name=function_name
    let n=1
    while (this.name_exists(name, bots)) {
      name=function_name+"_"+n
      n++
    }
    return name  
  }
  
  async copyBot(bot: IBot|undefined, newMenuItemId: string,x:number, y:number, precompiled:boolean) {

    if (!bot) return;
    if (!bot.id) return;

    const old_parent_id=bot.parent_id
    const old_id=bot.id
    const old_function_name=bot.function_name
    const old_function_code=bot.function_code
    const old_function_call=bot.function_call
    const oldx=bot.x
    const oldy=bot.y
    const old_name=bot.name
    const old_type=bot.type

    const user:IUser=  bus.get_user()
    const bots:IBot[] = await this.getBotsForParentId(newMenuItemId, user)
    const name = await this.rename_function(bots, bot.function_name)

    bot.id=undefined
    bot.parent_id = newMenuItemId

    bot.function_name = name
    if (!precompiled) {
      bot.function_code = this.replaceAllOccurrences(bot.function_code, old_function_name, name)
      bot.function_call = this.replaceAllOccurrences(bot.function_call, old_function_name, name)
    }
    if (!bot.name) bot.name=bot.function_name
    bot.name = this.replaceAllOccurrences(bot.name, old_function_name, name)
    bot.type=botType
    bot.x=x
    bot.y=y
    const new_bot = await bus.api("/api/ai/folder/save", { obj: bot });
   
    bot.id = old_id
    bot.parent_id = old_parent_id

    bot.function_name =  old_function_name
    bot.function_code = old_function_code
    bot.function_call = old_function_call
    bot.x=oldx
    bot.y=oldy
    bot.name=old_name
    bot.type=old_type

    return new_bot
  }

  async deleteBot(obj: IBot): Promise<void> {
    const id = obj.id
    if (!id) return;
    return await bus.api("/api/ai/bot/del", { obj: obj });
  }

  async selectFolder(menuItem: IFolder|undefined) {
    this.selectedFolder = menuItem
  }

  async saveFolder(menuItem: IFolder): Promise<IFolder|undefined> {
    return await bus.api("/api/ai/folder/save", { obj: menuItem });
  }

  async deleteFolder(menuItem: IFolder): Promise<IFolder|undefined> {
    return await bus.api("/api/ai/folder/del", { obj: menuItem });
  }

  async getFoldersForParentId(parent_id: string | undefined, user:IUser): Promise<IFolder[]> {
    let menus = await bus.api("/api/ai/folder/getFolders", {obj: { parent_id: parent_id, user:user}});
    if (!menus) menus=[]
    return menus
  }

  async getBotsForParentId(parent_id: string | undefined, user:IUser): Promise<IBot[]> {
    let list = await bus.api("/api/ai/folder/getBots", {obj: { parent_id: parent_id, user:user}});
    if (!list) list=[]
    return list
  }

  async getCtxForParentId(parent_id: string | undefined, user:IUser): Promise<ICtx|undefined> {
    const ret = await bus.api("/api/ai/folder/getCtx", {obj: { parent_id: parent_id, user:user}});
    if (ret && ret.id) return ret;
    return undefined    
  }

}





